<template>
  <!-- New Row for Transparency Button -->
  <div class="w-full text-center my-2 trasparenza">
    <a href="https://www.controcorrente.it/footer/trasparenza">
      <img
        class="inline-block object-contain"
        src="/assets/Desktop/12_Footer/IBL_Sito_ControCorrente_Trasparenza.png"
      />
    </a>
  </div>
  <div class="bg-deepWater lg:bg-transparent container px-2 mx-auto">
    <div class=" flex items-center justify-between w-full h-12">
      <div @click="menu = false">
        <router-link class=" mr-14 block px-2 py-1 border-transparent" to="/">
          <img
            class="object-scale-down h-8"
            src="/assets/Desktop/IBL_Sito_ControCorrente_Logo_Menu.png"
          />
        </router-link>
      </div>
      <div class="ml-auto flex items-center">
        <transition name="fade">
          <nav v-if="isDesktop && !showMenu">
            <ul class="flex -mx-2">
              <template v-for="route in menuInline" :key="route">
                <template v-if="route.meta.flatten">
                  <li v-for="child in getChildren(route)" :key="child">
                    <router-link
                      class="rounded-2xl whitespace-nowrap px-2 py-1 mx-2 cursor-pointer"
                      :to="`${route.path}/${child.path}`"
                      v-text="getLabel(child)"
                    />
                  </li>
                </template>
                <template v-else>
                  <li>
                    <router-link
                      class="rounded-2xl whitespace-nowrap px-2 py-1 mx-2 cursor-pointer"
                      :to="route.path"
                      v-text="getLabel(route)"
                    />
                  </li>
                </template>
              </template>
            </ul>
          </nav>
        </transition>
        <hamburgher @click="toggleMenu" :active="menu" class="p-2" />
      </div>
    </div>
    <transition name="menu">
      <div class="fixed inset-0 mb-12" v-if="showMenu" @wheel.stop>
        <div
          class="menu--block md:container relative inset-0 h-full mx-auto"
          @click="this.menu = false"
        >
          <div
            @click.stop
            class="bg-deepWater  md:w-1/3 md:min-w-min absolute inset-y-0 right-0 h-full min-w-full overflow-x-hidden"
          >
            <nav class="h-full">
              <ul class="custom-scrollbar flex flex-col h-full overflow-y-auto">
                <nav-item
                  @click="route.children.length === 0 && toggleMenu"
                  @close="toggleMenu"
                  v-for="route in menuFull"
                  :key="route.path"
                  :route="route"
                />
                <li class="border-b border-brand">
                  <div class="flex-nowrap flex items-center cursor-pointer">
                    <a
                      class="hover-hover:hover:text-primary whitespace-nowrap block w-full p-4 text-lg font-bold text-center"
                      href="https://www.iblbanca.it/iblclub.html"
                      target="_blank"
                      >IBL Club
                    </a>
                  </div>
                  <hr />
                </li>
                <li class="mt-auto mb-4">
                  <a
                    class="whitespace-nowrap rounded-2xl w-min flex items-center justify-center p-4 mx-auto text-center border"
                    :href="areaClientiLink"
                    target="_external"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      class="inline-block w-4 h-4 mr-2 fill-current"
                    >
                      <path
                        d="M18.8 9H18V6A6 6 0 006 6v3h-.8C4 9 3 10 3 11.3v10.4C3 23 4 24 5.3 24h13.4c1.3 0 2.3-1 2.3-2.3V11.3C21 10 20 9 18.7 9zM8 6a4 4 0 018 0v3H8zm5 10.7V19a1 1 0 11-2 0v-2.3a2 2 0 011-3.7 2 2 0 011 3.7z"
                      />
                    </svg>
                    Area Clienti
                  </a>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import _ from "lodash";
import Hamburgher from "@/components/nav/Hamburgher";
import NavItem from "./NavItem.vue";
export default {
  components: { Hamburgher, NavItem },
  props: {
    areaClientiLink: String,
    desktop: {
      type: Boolean
    }
  },
  data: () => ({
    menu: false
  }),
  computed: {
    showMenu() {
      return /* !this.isDesktop &&  */ this.menu;
    },
    mainMenu() {
      let routes = this.$router.getRoutes();
      routes = _.filter(routes, i => /^\/[^/]+$/.test(i.path));
      routes = _.map(
        routes,
        _.partialRight(_.pick, ["name", "path", "children", "meta", "redirect"])
      );

      return routes;
    },
    menuInline() {
      let routes = this.mainMenu;
      routes = _.filter(routes, i => !_.get(i.meta, "hideMenu.inline"));
      return this.sortMenu(routes);
    },
    menuFull() {
      let routes = this.mainMenu;
      routes = _.filter(routes, i => !_.get(i.meta, "hideMenu.main"));

      return this.sortMenu(routes);
    }
  },
  methods: {
    getLabel(item) {
      return _.get(item, "meta.label") || item.name;
    },
    toggleMenu() {
      this.menu = !this.menu;
    },
    getChildren(route) {
      return _.filter(
        route.children,
        i => !_.get(i.meta, "hideAsChild.inline")
      );
    },
    sortMenu(menu) {
      return _.sortBy(menu, [
        i => {
          const order =
            i.children[0] && i.children[0].meta.order
              ? i.children[0].meta.order
              : i.meta.order;
          return order;
        }
      ]);
    }
  }
};
</script>

<style scoped>
@media (min-width: 1024px) {
  .router-link-active {
    @apply border;
  }
  .trasparenza {
    position: absolute;
    bottom: 2px;
    left: 78px;
    width: 112px;
  }
}
@media screen and (max-width: 1280px) {
  .trasparenza {
    position: absolute;
    bottom: 60px;
    left: 3px;
    width: 90px;
  }
}
.menu--block:after {
  @apply block absolute inset-y-0 left-full bg-deepWater w-screen bg-opacity-90 pointer-events-none;
  content: "";
}
</style>
